import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; // Or use @highcharts/react components
import 'highcharts/modules/exporting';

interface ChartProps {
  title: string;
  height: number;
}

const DiversityBar: React.FC<ChartProps> = ({ title, height = 345 }) => {
  const [sales, setSales] = React.useState([]);
  const [drilldown, setDrilldown] = React.useState([]);

  const chartComponentRef = React.useRef<HighchartsReact.RefObject>(null);
  React.useEffect(() => {
    fetch(`/dashboard/diversity-of-sales/?entity_id=${localStorage.getItem('entity_id')}`)
      .then(response => response.json())
      .then(data => 
        setTimeout(() => {
          setSales(data.sales);
          setDrilldown(data.drilldown);
        }, 100)
      );

    const handleResize = () => {
      if (chartComponentRef.current && chartComponentRef.current.chart) {
        chartComponentRef.current.chart.reflow();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const options: Highcharts.Options = {
        chart: {
            type: 'column',
            zooming: {
                type: 'xy' as const
            }
        },
        title: {
            text: title,
            align: 'left'
        },
        
        xAxis: {
            type: 'category',
            title: {
                text: 'Categories',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },

        yAxis: {
            min: 0,
            title: {
                text: 'Number of Products',
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            },
            labels: {
                formatter: function(this: Highcharts.AxisLabelsFormatterContextObject) {
                    const v = this.value as number;
                    const absv = Math.abs(v);
                    if (absv >= 1000000) return v / 1000000 + 'M';
                    if (absv >= 1000) return v / 1000 + 'K';
                    return String(v);
                },
                style: {
                    fontFamily: 'Trebuchet MS'
                }
            }
        },

        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function() {
                            console.log(this.category);
                        }
                    }
                }
            }
        },

        tooltip: {
            formatter: function(this: Highcharts.Point) {
                return `<span style="font-family: Trebuchet MS;">Total findings: ${new Intl.NumberFormat('en-US').format(this.y)}</span>`;
            },
        },

        series: [
            {
                type: 'column',
                name: 'Number of Products',
                data: Object.entries(sales).map(([key, value]) => ({
                    name: key,
                    y: value as number,
                    drilldown: key
                }))
            }
        ],
        drilldown: {
            breadcrumbs: {
                position: {
                    align: 'right'
                }
            },
           
            series: [
                ...Object.entries(drilldown).map(([key, value]) => ({
                    type: 'column' as const,
                    name: key as string,
                    id: key as string,
                    data: [Object.entries(drilldown).map(([key, value]) => ([key, value]))]
                }))
            ]
        }
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                allowChartUpdate={true}
                exportEnabled={true}
                ref={chartComponentRef}
                containerProps={{ style: { width: '100%', height: height, borderRadius: 5, boxShadow: 'none', margin: 0, padding: 0 } }}
            />
        </div>
    );
};

export default DiversityBar;
